"use client";

import React from "react";
import { ShieldCheck, Award, ChevronRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const teamMembers = [{
  name: "Marcus Thorne",
  role: "Managing Partner",
  certs: "Global 500: Shell | AI Focus: Agentic Strategy",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/marcus_thorne.png"
}, {
  name: "Sarah Vance",
  role: "AI Strategy Director",
  certs: "Global 500: Pfizer | AI Focus: LLM Integration",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/sarah_vance.png"
}, {
  name: "Julian Chen",
  role: "Process Excellence Lead",
  certs: "Global 500: Toyota | AI Focus: Process Automation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/julian_chen.png"
}, {
  name: "Elena Rodriguez",
  role: "Change Management Principal",
  certs: "Global 500: HSBC | AI Focus: Cultural Adoption",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/elena_rodriguez.png"
}];
export default function SeniorLedExcellence() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}